<template>
  <div id="noteNav">
    <router-link tag="div" class="logoHolder" to="/meetings">
      <img src="../assets/fisher-insta-meetings.svg" />
    </router-link>
    <div class="linkHolder" ref="mobMenu" :class="mobileMenu ? 'active' : ''">
      <div class="mobileVisibe">
        <router-link tag="div" class="link" to="/meetings">
          <h2>
            <img src="../assets/fisher-icon-meetings.svg" />Meetings
          </h2>
        </router-link>
<!--        <router-link tag="div" class="link" to="/people">-->
<!--          <h2>-->
<!--            <img src="../assets/fisher-icon-people.svg" />People-->
<!--          </h2>-->
<!--        </router-link>-->
<!--        <router-link tag="div" class="link" to="/attendance">-->
<!--          <h2>-->
<!--            <img src="../assets/fisher-icon-attendance.svg" />Attendance-->
<!--          </h2>-->
<!--        </router-link>-->
        <!-- <router-link tag="div" class="link" to="/notifications">
          <h2>
            <img src="../assets/fisher-icon-notifications.svg" />Notifications
          </h2>
        </router-link> -->
<!--      <div class="customLink">-->
<!--        <button type="button" @click="openTimezonePicker">Change CoreGroup Timezone</button>-->
<!--      </div>-->

        <div class="customLink">
          <button type="button" @click="logout">SIGN OUT</button>
        </div>
        <button class="createNew" @click="openModal">
          <img src="../assets/fisher-icon-plus.svg" />
          <h2>New instant meeting</h2>
        </button>
      <div class="userInfo">
        <div class="nameHolder">
          <h3>{{leaderDetails.people.firstName}}&nbsp;{{leaderDetails.people.lastName}}</h3>
          <p>{{leaderDetails.securityRole.securityRoleName}}</p>
        </div>
      </div>
      </div>
      <div class="hamburger" ref="hamburger" @click="openMenu()" :class="mobileMenu ? 'active' : ''">
        <span></span>
        <span></span>
        <span></span>
      </div>
    </div>
  </div>
</template>

<script>
import {mapActions, mapGetters, mapMutations} from "vuex";

export default {
  name: "Navigation",
  data() {
    return {
      mobileMenu: false,
    };
  },
  methods: {
      ...mapMutations(["toggleModal", "setMeetingModalType", "setPersonId"]),
    ...mapActions(["signOut"]),
    logout() {
      this.signOut();
      this.$router.push(`/signin?data=${this.$route.query.data}`);
    },
    openModal() {
      this.toggleModal();
      this.setMeetingModalType('create');
      },
    openTimezonePicker() {
      this.$store.commit("showTimeModal", true);
    },
    openMenu() {
      this.mobileMenu = !this.mobileMenu
    }
   },

  computed: { ...mapGetters(["leaderDetails"]) }
};
</script>

<style lang="scss" scoped src="@/styles/style-navigation.scss">
</style>
